var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"broker-details"},[_c('Snapshot'),_c('BrokerList',{staticClass:"broker-holding-list"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }